export default {
      id: "chat-usage",
      viewBox: "0 0 48 48",
      url: "/dist/svg/" + "sprite.svg#chat-usage",
      toString: function () {
        return this.url;
      }
    }